import Modal from '~/js/components/global/Modal';

const ModalLevels = () => {
  const cdnUrl = window.beaches_app.global.cdn_url;

  return (
    <Modal id="villages">
      <img src={`${cdnUrl}/resorts/accommodations/villages.jpg`} alt="villages map" className="img-responsive"/>
      <div className="villages-info">
        <div className="village">
          <div className="title">Caribbean & Seaside Village</div>
          <div className="description">Located just steps from the world's best beach, the Caribbean and Seaside Villages are a garden oasis overlooking 12 miles of white-sand and crystal clear turquoise water.</div>
          <a href="/resorts/turks-caicos/caribbean-village/" className="link">visit the CARIBBEAN & SEASIDE villages<span className="icon-link-arrow-beaches"/></a>
        </div>
        <hr/>
        <div className="village">
          <div className="title">Italian Village</div>
          <div className="description">Everything here has an Italian flavor, from the fountains and statues to the cuisine. It's like staying on the Italian Riviera, but with a decidedly Caribbean twist.</div>
          <a href="/resorts/turks-caicos/italian-village/" className="link">visit the italian village<span className="icon-link-arrow-beaches"/></a>
        </div>
        <hr/>
        <div className="village">
          <div className="title">Key West Village</div>
          <div className="description">Experience the carefree lifestyle of the Florida Keys amidst the breathtaking beauty of the Caribbean at Beaches Turks & Caicos' Key West Village.</div>
          <a href="/resorts/turks-caicos/keywest-village/" className="link">visit the key west village<span className="icon-link-arrow-beaches"/></a>
        </div>
        <hr/>
        <div className="village">
          <div className="title">French Village</div>
          <div className="description">Our French Village is like stepping into a lush garden at Versailles, only with a half-acre pool, a swim-up bar and an amazing Pirates Island waterpark. </div>
          <a href="/resorts/turks-caicos/french-village/" className="link">visit the french village<span className="icon-link-arrow-beaches"/></a>
        </div>
      </div>
    </Modal>
  );
};

export default ModalLevels;
